//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sort from "@/transitions/Sort";
import Row from "./body/Row";
import RowAdmin from "./body/RowAdmin";
import draggable from "vuedraggable";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "MatrixBody",
  props: ["cols"],
  components: {
    matrixRow: Row,
    matrixDrag: draggable,
    matrixRowAdmin: RowAdmin
  },
  data() {
    return {
      drag: false
    };
  },
  computed: {
    ...mapGetters(["authorized", "results", "computed", "sortable"]),
    rows: {
      get() {
        return Object.entries(this.results);
      },
      set(value) {
        this.updateRows(Object.fromEntries(value));
      }
    },
    labels() {
      return this.computed.headers.map(col => col._display);
    },
    dragOptions() {
      return {
        group: "rows",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    ...mapMutations(["updateRows"]),
    ...mapActions(["save"]),
    async doSave() {
      let id = document.querySelector("#tableId").value;
      await this.save(id);
    },
    showModal(type, data, insertAfter) {
      this.$modal.show("row-editor", { type, data, insertAfter });
    },
    handelExternalLinks() {
      let links = this.$el.querySelectorAll("a[href]");
			let siteHost = window.location.host;
      links.forEach(link => {
        let urlHost = link
          .getAttribute("href")
          .match(/(?:^https?\:)?(?:\/\/)(?:www\.)?([^\/?#]+)(?:[\/?#]|$)/i);
        urlHost = urlHost ? urlHost[1] : siteHost;
        if (siteHost != urlHost) {
          link.setAttribute("target", "_blank");
        }
      });
    }
  },
  mounted() {
		this.handelExternalLinks()
	},
  updated() {
		this.handelExternalLinks()
	}
};
